import { Col, Grid, message, Row, Spin } from 'antd';
import { Routes } from 'config/routes';
import { useGetDonorQuery } from 'gql/types';
import { Button } from 'modules/common/components';
import { useDonorDvmExams } from 'modules/donor/hooks/useDonorDvmExams';
import { useDvmExamModal } from 'modules/donor/hooks/useDvmExamModal';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import DvmExamModal from '../DvmExamModal';
import { DvmExamTable } from '../DvmExamTable';

export const DonorDvmExams = () => {
  const { t } = useTranslation('donor.DonorDvmExam');
  const navigate = useNavigate();
  const params = useParams();
  const shortDonorId = params.id || '';
  const breakpoints = Grid.useBreakpoint();

  // TODO: Implement it later after agreement about permissions
  // const canUpdateDvmExam =
  //   useCurrentUser().data?.permissions?.updateDvmExamData || false;

  const canUpdateDvmExam = true;

  const donorQuery = useGetDonorQuery({
    variables: {
      input: {
        id: shortDonorId,
      },
    },
    onError: (err) => {
      message.error(err.message);
      if (err.message === 'Not Found') {
        navigate(Routes.NotFound);
        return;
      }

      navigate(Routes.IndividualDonors);
    },
  });
  const donorId = donorQuery.data?.getDonor.id;
  const dvmExams = useDonorDvmExams(donorId);
  const modal = useDvmExamModal();

  const isLoading = donorQuery.loading || dvmExams.isLoading;
  const isBreakpointsEmpty = Object.keys(breakpoints).length === 0;

  return (
    <Spin spinning={isLoading}>
      <Row gutter={[0, 10]}>
        {canUpdateDvmExam && (
          <Col span={24}>
            <Button onClick={modal.openForCreate}>{t('newDvmExam')}</Button>
          </Col>
        )}
        <Col span={24}>
          <DvmExamModal
            {...modal.modalConfig}
            dvmExam={modal.selectedDvmExam}
            hide={modal.close}
            donorId={donorId}
          />
          {!isBreakpointsEmpty && (
            <DvmExamTable
              dvmExams={dvmExams.dvmExams}
              updateDvmExamHandler={modal.openForEdit}
              removeDvmExamHandler={dvmExams.removeDvmExamHandler}
              pagination={dvmExams.pagination}
              sort={dvmExams.sort}
            />
          )}
        </Col>
      </Row>
    </Spin>
  );
};
